"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "var(--sds--ursa-icons--background-color, transparent)",
  d: "M15 10a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1zm0 5.5a1 1 0 0 1 1-1h2.5a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H16a1 1 0 0 1-1-1z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M6.842 15.005A3.44 3.44 0 0 0 3.4 18.446a.7.7 0 1 1-1.4 0 4.84 4.84 0 0 1 4.842-4.842H11.5a.7.7 0 1 1 0 1.4zm1.702-8.751a2.456 2.456 0 1 1 0 4.912 2.456 2.456 0 0 1 0-4.912M12.4 8.71a3.856 3.856 0 1 0-7.712 0 3.856 3.856 0 0 0 7.712 0m3.2.994a.4.4 0 0 0-.4.4v.602c0 .22.179.4.4.4h4.6a.4.4 0 0 0 .4-.4v-.601a.4.4 0 0 0-.4-.4zm-1.8.4a1.8 1.8 0 0 1 1.8-1.8h4.6a1.8 1.8 0 0 1 1.8 1.8v.602a1.8 1.8 0 0 1-1.8 1.8h-4.6a1.8 1.8 0 0 1-1.8-1.8zm1.8 5.09a.4.4 0 0 0-.4.4v.602a.4.4 0 0 0 .4.4h2.882a.4.4 0 0 0 .4-.4v-.601a.4.4 0 0 0-.4-.4zm-1.8.4a1.8 1.8 0 0 1 1.8-1.8h2.882a1.8 1.8 0 0 1 1.8 1.8v.602a1.8 1.8 0 0 1-1.8 1.8H15.6a1.8 1.8 0 0 1-1.8-1.8z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=ResourceManagementIcon24.js.map